import { Injectable, Inject, PLATFORM_ID, EventEmitter, Component, forwardRef, NgZone, ViewChild, Input, Output, NgModule } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { AsyncSubject, fromEvent, Subject } from 'rxjs';
import { debounceTime, map } from 'rxjs/operators';
import { isPlatformBrowser } from '@angular/common';

import * as ɵngcc0 from '@angular/core';

const _c0 = ["htmlTextAreaElement"];
class CkeditorService {
}
CkeditorService.ɵfac = function CkeditorService_Factory(t) { return new (t || CkeditorService)(); };
CkeditorService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: CkeditorService, factory: CkeditorService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CkeditorService, [{
        type: Injectable
    }], null, null); })();

class OptionsService {
}
OptionsService.ɵfac = function OptionsService_Factory(t) { return new (t || OptionsService)(); };
OptionsService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: OptionsService, factory: OptionsService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OptionsService, [{
        type: Injectable
    }], null, null); })();

class SetupService {
    constructor(platformId, options) {
        /**
         * Judge loading status
         */
        this.loaded = new AsyncSubject();
        if (isPlatformBrowser(platformId) && !this.elementScripts && !this.CKEDITOR) {
            this.elementScripts = document.createElement('script');
            this.elementScripts.setAttribute('type', 'text/javascript');
            this.elementScripts.setAttribute('src', options.url);
            document.body.appendChild(this.elementScripts);
            fromEvent(this.elementScripts, 'load').subscribe(() => {
                this.CKEDITOR = CKEDITOR;
                this.loaded.next(null);
                this.loaded.complete();
            });
            fromEvent(this.elementScripts, 'error').subscribe(() => {
                console.warn('CKEditor load failed');
            });
        }
    }
}
SetupService.ɵfac = function SetupService_Factory(t) { return new (t || SetupService)(ɵngcc0.ɵɵinject(PLATFORM_ID), ɵngcc0.ɵɵinject(OptionsService)); };
SetupService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: SetupService, factory: SetupService.ɵfac });
SetupService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] },
    { type: OptionsService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SetupService, [{
        type: Injectable
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [PLATFORM_ID]
            }] }, { type: OptionsService }]; }, null); })();

class NgxCkeditorComponent {
    constructor(setupService, optionsService, ckeditorService, ngZone) {
        this.setupService = setupService;
        this.optionsService = optionsService;
        this.ckeditorService = ckeditorService;
        this.ngZone = ngZone;
        this.config = {};
        this.fileUploadRequestCustom = false;
        this.fileUploadResponseCustom = false;
        this.ready = new EventEmitter();
        this.focus = new EventEmitter();
        this.blur = new EventEmitter();
        this.fileUploadRequest = new EventEmitter();
        this.fileUploadResponse = new EventEmitter();
        this.editorReady = new AsyncSubject();
        this.editorChangeEvents = new Subject();
    }
    /**
     * Writes a new value to the element.
     */
    writeValue(value) {
        if (!value) {
            if (this.editor) {
                this.editor.setData('');
            }
            return;
        }
        this.editorReady.subscribe(() => {
            this.editor.setData(value);
        });
    }
    /**
     * Registers a callback function that is called when the control's value changes in the UI.
     */
    registerOnChange(fn) {
        this.onChange = fn;
    }
    /**
     * Registers a callback function is called by the forms API on initialization to update the form model on blur.
     */
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    /**
     * Function that is called by the forms API when the control status changes to or from 'DISABLED'.
     */
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
        this.editorReady.subscribe(() => {
            this.editor.setReadOnly(this.disabled);
        });
    }
    ngOnInit() {
        this.editorInitial();
        this.editorChangeEvents.pipe(debounceTime(200), map((event) => event.editor.getData())).subscribe(html => {
            if (this.onChange) {
                const HTMLRows = html.replace(/\n/g, '');
                this.onChange(HTMLRows);
            }
        });
    }
    ngAfterViewInit() {
        this.editorFactory();
    }
    ngOnChanges(changes) {
        if (changes.hasOwnProperty('inline') && !changes.inline.firstChange) {
            this.inline = changes.inline.currentValue;
            this.update();
        }
        if (changes.hasOwnProperty('locale') && !changes.locale.firstChange) {
            this.setLanguage(changes.locale.currentValue);
            this.update();
        }
        if (changes.hasOwnProperty('config') && !changes.config.firstChange) {
            delete this.config.language;
            this.config = changes.config.currentValue;
            this.update();
        }
    }
    ngOnDestroy() {
        this.editorDestroy();
    }
    /**
     * Update Ckeditor
     */
    update() {
        this.editorDestroy();
        this.editorReady = new AsyncSubject();
        this.editorChangeEvents = new Subject();
        this.editorInitial();
        this.editorFactory();
    }
    /**
     * Initial the configuration of ckeditor
     */
    editorInitial() {
        if (!this.id) {
            this.id = 'ckeditor_' + (Math.random() * 10000).toFixed(0);
        }
        if (this.optionsService.config) {
            Object.assign(this.config, this.optionsService.config);
        }
        if (this.locale) {
            this.setLanguage(this.locale);
        }
    }
    /**
     * Load ckeditor
     */
    editorFactory() {
        this.setupService.loaded.subscribe(() => {
            if (!this.inline) {
                this.setupService.CKEDITOR.disableAutoInline = false;
                this.editor = this.setupService.CKEDITOR.replace(this.htmlTextAreaElement.nativeElement, this.config);
            }
            else {
                this.setupService.CKEDITOR.disableAutoInline = true;
                this.editor = this.setupService.CKEDITOR.inline(this.htmlTextAreaElement.nativeElement, this.config);
            }
            if (this.disabled !== undefined) {
                this.editor.config.readOnly = this.disabled;
            }
            this.ngZone.runOutsideAngular(() => {
                this.editor.on('instanceReady', (event) => {
                    this.ngZone.run(() => {
                        this.ready.emit(event);
                        this.editorReady.next(null);
                        this.editorReady.complete();
                    });
                });
                this.editor.on('change', (event) => {
                    this.ngZone.run(() => {
                        this.editorChangeEvents.next(event);
                    });
                });
                this.editor.on('focus', (event) => {
                    this.ngZone.run(() => {
                        this.focus.emit(event);
                    });
                });
                this.editor.on('blur', (event) => {
                    this.ngZone.run(() => {
                        this.blur.emit(event);
                        if (this.onTouched) {
                            this.onTouched();
                        }
                    });
                });
                this.editor.on('fileUploadRequest', (event) => {
                    this.ngZone.run(() => {
                        if (this.fileUploadRequestCustom) {
                            this.fileUploadRequest.emit(event);
                        }
                        else if (this.ckeditorService.fileUploadRequest) {
                            this.ckeditorService.fileUploadRequest(event);
                        }
                    });
                });
                this.editor.on('fileUploadResponse', (event) => {
                    this.ngZone.run(() => {
                        if (this.fileUploadResponseCustom) {
                            this.fileUploadResponse.emit(event);
                        }
                        else if (this.ckeditorService.fileUploadResponse) {
                            this.ckeditorService.fileUploadResponse(event);
                        }
                    });
                });
            });
        });
    }
    /**
     * Destroy ckeditor
     */
    editorDestroy() {
        if (this.editor) {
            this.editor.destroy();
            this.editor = null;
            this.editorReady.unsubscribe();
            this.editorChangeEvents.unsubscribe();
        }
    }
    setLanguage(locale) {
        switch (locale) {
            case 'en_us':
                this.config.language = 'en';
                break;
            case 'zh_cn':
                this.config.language = 'zh-CN';
                break;
        }
    }
}
NgxCkeditorComponent.ɵfac = function NgxCkeditorComponent_Factory(t) { return new (t || NgxCkeditorComponent)(ɵngcc0.ɵɵdirectiveInject(SetupService), ɵngcc0.ɵɵdirectiveInject(OptionsService), ɵngcc0.ɵɵdirectiveInject(CkeditorService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
NgxCkeditorComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NgxCkeditorComponent, selectors: [["ngx-ckeditor"]], viewQuery: function NgxCkeditorComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.htmlTextAreaElement = _t.first);
    } }, inputs: { config: "config", fileUploadRequestCustom: "fileUploadRequestCustom", fileUploadResponseCustom: "fileUploadResponseCustom", inline: "inline", id: "id", locale: "locale" }, outputs: { ready: "ready", focus: "focus", blur: "blur", fileUploadRequest: "fileUploadRequest", fileUploadResponse: "fileUploadResponse" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => NgxCkeditorComponent),
                multi: true
            }
        ]), ɵngcc0.ɵɵNgOnChangesFeature], decls: 2, vars: 1, consts: [[3, "id"], ["htmlTextAreaElement", ""]], template: function NgxCkeditorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "textarea", 0, 1);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("id", ctx.id);
    } }, styles: ["textarea[_ngcontent-%COMP%] {\n    display: none;\n  }"] });
NgxCkeditorComponent.ctorParameters = () => [
    { type: SetupService },
    { type: OptionsService },
    { type: CkeditorService },
    { type: NgZone }
];
NgxCkeditorComponent.propDecorators = {
    htmlTextAreaElement: [{ type: ViewChild, args: ['htmlTextAreaElement', { static: true },] }],
    id: [{ type: Input }],
    locale: [{ type: Input }],
    config: [{ type: Input }],
    inline: [{ type: Input }],
    fileUploadRequestCustom: [{ type: Input }],
    fileUploadResponseCustom: [{ type: Input }],
    ready: [{ type: Output }],
    focus: [{ type: Output }],
    blur: [{ type: Output }],
    fileUploadRequest: [{ type: Output }],
    fileUploadResponse: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxCkeditorComponent, [{
        type: Component,
        args: [{
                selector: 'ngx-ckeditor',
                template: `<textarea #htmlTextAreaElement [id]="id"></textarea>`,
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => NgxCkeditorComponent),
                        multi: true
                    }
                ],
                styles: [`textarea {
    display: none;
  }`]
            }]
    }], function () { return [{ type: SetupService }, { type: OptionsService }, { type: CkeditorService }, { type: ɵngcc0.NgZone }]; }, { config: [{
            type: Input
        }], fileUploadRequestCustom: [{
            type: Input
        }], fileUploadResponseCustom: [{
            type: Input
        }], ready: [{
            type: Output
        }], focus: [{
            type: Output
        }], blur: [{
            type: Output
        }], fileUploadRequest: [{
            type: Output
        }], fileUploadResponse: [{
            type: Output
        }], inline: [{
            type: Input
        }], id: [{
            type: Input
        }], htmlTextAreaElement: [{
            type: ViewChild,
            args: ['htmlTextAreaElement', { static: true }]
        }], locale: [{
            type: Input
        }] }); })();

class NgxCkeditorModule {
    static forRoot(options) {
        return {
            ngModule: NgxCkeditorModule,
            providers: [
                SetupService,
                CkeditorService,
                { provide: OptionsService, useValue: options }
            ]
        };
    }
}
NgxCkeditorModule.ɵfac = function NgxCkeditorModule_Factory(t) { return new (t || NgxCkeditorModule)(); };
NgxCkeditorModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NgxCkeditorModule });
NgxCkeditorModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxCkeditorModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    NgxCkeditorComponent
                ],
                exports: [
                    NgxCkeditorComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgxCkeditorModule, { declarations: [NgxCkeditorComponent], exports: [NgxCkeditorComponent] }); })();

/*
 * Public API Surface of ngx-ckeditor4
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CkeditorService, NgxCkeditorModule, NgxCkeditorComponent as ɵa, SetupService as ɵb, OptionsService as ɵc };

